<template>
  <p class="badge2" :class="type">{{ label }}</p>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'info',
  },
});
</script>

<style scoped lang="scss"></style>
